
import { Component, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { DatabaseInterface, DatabaseRepositoryInterface } from '@/services/Database/interfaces';
import { WPXFormValue } from '@/components/templates/WPXForm';
import { CreateUserForm } from '@/services/Database/forms/CreateUserForm';
import DatabaseSelectionDialog from "@/views/pages/database/DatabaseSelectionDialog.vue";
import { ServerInterface, ServerRepositoryInterface } from '@/services/Server/Interfaces';
import PageHeader from '@/components/layout/PageHeader.vue';

@Component({
  components: { DatabaseSelectionDialog, PageHeader },
  mixins: [
    Themeable,
  ],
  inject: [
    'serverRepository',
    'databaseRepository',
  ],
})
export default class CreateUser extends Vue {
  private form: WPXFormValue<CreateUserForm> = new WPXFormValue(CreateUserForm);
  private databases: DatabaseInterface[] = [];

  private serverRepository!: ServerRepositoryInterface;
  private databaseRepository!: DatabaseRepositoryInterface;
  private servers: ServerInterface[] = [];

  public selectionDialog: string = "";

  get selectedDatabaseId(): number | undefined {
    if (this.databases.length <= 0) {
      this.form.data.databaseId = undefined;
      return undefined;
    }
    this.form.data.databaseId = this.databases[0].id;
    return this.form.data.databaseId;
  }

  public async created(): Promise<void> {
    try {
      await this.initialize();
    } catch (e) {
      this.$errorDialog.show(e.response?.data?.message || e.message);
    }
  }

  private async initialize(): Promise<void> {
    this.servers = await this.serverRepository.getAllServers();
  }

  public async showSelectionDialog(): Promise<void> {
    this.selectionDialog = 'database-selection-dialog';
  }

  public async destroyDialog(): Promise<void> {
    this.selectionDialog = '';
  }

  public async onDatabaseSelected(databaseSelectedId?: string): Promise<void> {
    const selection = JSON.parse(databaseSelectedId) as DatabaseInterface;
    this.databases = [selection];
  }

  private async createUser(): Promise<void> {
    try {
      await this.databaseRepository.createUser({
        username: this.form.data.username,
        password: this.form.data.password,
        passwordConf: this.form.data.passwordConf,
        databaseId: this.form.data.databaseId,
      });

      this.$successDialog.show('User Created Successfully');
      await this.$router.push({ name: 'database_users_list' });
    } catch (e) {
      this.$errorDialog.show(e.response?.data?.message || e.message);
    }
  }

  private getServerName(serverId: string): string {
    const server = this.servers.find((s) => s._id === serverId);
    if (!server) {
      return '';
    }

    return server.hostname;
  }

  private remove(): void {
    this.databases = [];
  }
}
